import React from "react";
import ReactDOM from "react-dom";
import "typeface-lato";
import "typeface-quicksand";
import "typeface-roboto";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import App from "./App";
import { unregister } from "./registerServiceWorker";

ReactDOM.render(<App />, document.getElementById("root"));
unregister();



// WEBPACK FOOTER //
// ./src/index.js